export default __webpack_public_path__ + "static/media/more.4813ba2e.svg";